import React from 'react';
import { Card } from '../components/ui/Card';
import { formatCurrency } from '../utils/calculations';
export function BalanceSheet() {
  const balanceSheetData = {
    assets: {
      current: [{
        name: 'Cash and Cash Equivalents',
        amount: 125000
      }, {
        name: 'Accounts Receivable',
        amount: 45000
      }, {
        name: 'Inventory',
        amount: 18000
      }, {
        name: 'Prepaid Expenses',
        amount: 5000
      }],
      fixed: [{
        name: 'Property and Equipment',
        amount: 150000
      }, {
        name: 'Vehicles',
        amount: 45000
      }, {
        name: 'Less: Accumulated Depreciation',
        amount: -35000
      }]
    },
    liabilities: {
      current: [{
        name: 'Accounts Payable',
        amount: 28000
      }, {
        name: 'Credit Cards',
        amount: 12000
      }, {
        name: 'Current Portion of Long-term Debt',
        amount: 15000
      }, {
        name: 'Accrued Expenses',
        amount: 8000
      }],
      longTerm: [{
        name: 'Long-term Debt',
        amount: 85000
      }, {
        name: 'Equipment Loans',
        amount: 25000
      }]
    }
  };
  const totalCurrentAssets = balanceSheetData.assets.current.reduce((sum, item) => sum + item.amount, 0);
  const totalFixedAssets = balanceSheetData.assets.fixed.reduce((sum, item) => sum + item.amount, 0);
  const totalAssets = totalCurrentAssets + totalFixedAssets;
  const totalCurrentLiabilities = balanceSheetData.liabilities.current.reduce((sum, item) => sum + item.amount, 0);
  const totalLongTermLiabilities = balanceSheetData.liabilities.longTerm.reduce((sum, item) => sum + item.amount, 0);
  const totalLiabilities = totalCurrentLiabilities + totalLongTermLiabilities;
  const totalEquity = totalAssets - totalLiabilities;
  return <div className="space-y-6" data-id="element-376">
      <div data-id="element-377">
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-378">Balance Sheet</h1>
        <p className="text-sm text-gray-600" data-id="element-379">
          As of{' '}
          {new Date().toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })}
        </p>
      </div>

      {/* Assets */}
      <Card data-id="element-380">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-381">Assets</h2>

        {/* Current Assets */}
        <div className="mb-6" data-id="element-382">
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3" data-id="element-383">
            Current Assets
          </h3>
          <div className="space-y-2" data-id="element-384">
            {balanceSheetData.assets.current.map((item, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-385">
                <span className="text-gray-700" data-id="element-386">{item.name}</span>
                <span className="font-medium text-gray-900" data-id="element-387">
                  {formatCurrency(item.amount)}
                </span>
              </div>)}
            <div className="flex justify-between items-center py-2 font-semibold" data-id="element-388">
              <span className="text-gray-900" data-id="element-389">Total Current Assets</span>
              <span className="text-gray-900" data-id="element-390">
                {formatCurrency(totalCurrentAssets)}
              </span>
            </div>
          </div>
        </div>

        {/* Fixed Assets */}
        <div className="mb-4" data-id="element-391">
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3" data-id="element-392">
            Fixed Assets
          </h3>
          <div className="space-y-2" data-id="element-393">
            {balanceSheetData.assets.fixed.map((item, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-394">
                <span className={item.amount < 0 ? 'text-gray-600 pl-4' : 'text-gray-700'} data-id="element-395">
                  {item.name}
                </span>
                <span className={`font-medium ${item.amount < 0 ? 'text-gray-600' : 'text-gray-900'}`} data-id="element-396">
                  {formatCurrency(item.amount)}
                </span>
              </div>)}
            <div className="flex justify-between items-center py-2 font-semibold" data-id="element-397">
              <span className="text-gray-900" data-id="element-398">Total Fixed Assets</span>
              <span className="text-gray-900" data-id="element-399">
                {formatCurrency(totalFixedAssets)}
              </span>
            </div>
          </div>
        </div>

        <div className="pt-4 border-t-2 border-gray-300" data-id="element-400">
          <div className="flex justify-between items-center" data-id="element-401">
            <span className="text-lg font-bold text-gray-900" data-id="element-402">
              Total Assets
            </span>
            <span className="text-lg font-bold text-blue-600" data-id="element-403">
              {formatCurrency(totalAssets)}
            </span>
          </div>
        </div>
      </Card>

      {/* Liabilities */}
      <Card data-id="element-404">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-405">Liabilities</h2>

        {/* Current Liabilities */}
        <div className="mb-6" data-id="element-406">
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3" data-id="element-407">
            Current Liabilities
          </h3>
          <div className="space-y-2" data-id="element-408">
            {balanceSheetData.liabilities.current.map((item, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-409">
                <span className="text-gray-700" data-id="element-410">{item.name}</span>
                <span className="font-medium text-gray-900" data-id="element-411">
                  {formatCurrency(item.amount)}
                </span>
              </div>)}
            <div className="flex justify-between items-center py-2 font-semibold" data-id="element-412">
              <span className="text-gray-900" data-id="element-413">Total Current Liabilities</span>
              <span className="text-gray-900" data-id="element-414">
                {formatCurrency(totalCurrentLiabilities)}
              </span>
            </div>
          </div>
        </div>

        {/* Long-term Liabilities */}
        <div className="mb-4" data-id="element-415">
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3" data-id="element-416">
            Long-term Liabilities
          </h3>
          <div className="space-y-2" data-id="element-417">
            {balanceSheetData.liabilities.longTerm.map((item, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-418">
                <span className="text-gray-700" data-id="element-419">{item.name}</span>
                <span className="font-medium text-gray-900" data-id="element-420">
                  {formatCurrency(item.amount)}
                </span>
              </div>)}
            <div className="flex justify-between items-center py-2 font-semibold" data-id="element-421">
              <span className="text-gray-900" data-id="element-422">Total Long-term Liabilities</span>
              <span className="text-gray-900" data-id="element-423">
                {formatCurrency(totalLongTermLiabilities)}
              </span>
            </div>
          </div>
        </div>

        <div className="pt-4 border-t-2 border-gray-300" data-id="element-424">
          <div className="flex justify-between items-center" data-id="element-425">
            <span className="text-lg font-bold text-gray-900" data-id="element-426">
              Total Liabilities
            </span>
            <span className="text-lg font-bold text-red-600" data-id="element-427">
              {formatCurrency(totalLiabilities)}
            </span>
          </div>
        </div>
      </Card>

      {/* Equity */}
      <Card data-id="element-428">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-429">Owner's Equity</h2>
        <div className="space-y-2" data-id="element-430">
          <div className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-431">
            <span className="text-gray-700" data-id="element-432">Retained Earnings</span>
            <span className="font-medium text-gray-900" data-id="element-433">
              {formatCurrency(totalEquity * 0.7)}
            </span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-434">
            <span className="text-gray-700" data-id="element-435">Current Year Earnings</span>
            <span className="font-medium text-gray-900" data-id="element-436">
              {formatCurrency(totalEquity * 0.3)}
            </span>
          </div>
        </div>
        <div className="pt-4 border-t-2 border-gray-300" data-id="element-437">
          <div className="flex justify-between items-center" data-id="element-438">
            <span className="text-lg font-bold text-gray-900" data-id="element-439">
              Total Equity
            </span>
            <span className="text-lg font-bold text-green-600" data-id="element-440">
              {formatCurrency(totalEquity)}
            </span>
          </div>
        </div>
      </Card>

      {/* Summary */}
      <Card className="bg-gray-50" data-id="element-441">
        <div className="flex justify-between items-center" data-id="element-442">
          <span className="text-xl font-bold text-gray-900" data-id="element-443">
            Total Liabilities + Equity
          </span>
          <span className="text-xl font-bold text-blue-600" data-id="element-444">
            {formatCurrency(totalLiabilities + totalEquity)}
          </span>
        </div>
        <p className="text-xs text-gray-500 mt-2" data-id="element-445">
          Should equal Total Assets: {formatCurrency(totalAssets)}
        </p>
      </Card>
    </div>;
}